import Server from "../server";
import View from "../framework/view";
import template from "../../pugc/list-activity";
import {Activity} from "../bo/activity";
import {formatTimestamp} from "../misc/dates";

export class ListActivityView extends View {

    static classname = "list-activity-view";

    private readonly server = Server.instance();

    private activities? : Activity[];

    constructor() {
        super(ListActivityView.classname);
        this.refresh();
    }

    public refresh() {
        this.server.clearCache();
        const a_ = this.server.getActivity();

        a_.then((activity) => {
            this.activities = activity;
            this.update();
        });
    }

    protected render0(): JQuery<HTMLElement> {

        const filter0 = (this.elt().find("input.filter").val() as string || "").trim();

        const caseSensitive = filter0 && (filter0.toLowerCase() != filter0);

        const filter = ! caseSensitive ? filter0.toLowerCase() : filter0;

        const activities = (this.activities || []).filter(o => {
            let txt = [ o.username, o.description ].join(" ");
            if (! caseSensitive) {
                txt = txt.toLowerCase();
            }
            const ok = ! filter || txt.indexOf(filter) > -1;
            return ok;
        });

        console.log(`list_activity render activities=${this.activities?.length} filtered=${activities.length} filter=${filter} caseSensitive=${caseSensitive}`);

        const data = {
            activities: activities,
            formatTimestamp: formatTimestamp
        };

        const out = this.pug(template, data);

        return out;
    }

}

View.on(
    "." + ListActivityView.classname,
    "click",
    ".sync",
    function(that: ListActivityView, event, elt) {
        event.preventDefault();
        event.stopImmediatePropagation();
        that.refresh();
    });


View.on(
    "." + ListActivityView.classname,
    "input",
    ".filter",
    function(that: ListActivityView, event, elt) {
        event.preventDefault();
        event.stopImmediatePropagation();
        that.update(".list-activities");
    });


